var exports = {
  "q": "x93eb46d8--b1d05c--layer",
};

module.exports = exports;
